import { Component } from '@angular/core';
import { RoutingUrls } from '@cpak/enums';
import { AuthService } from '../../services/auth/auth.service';
import { Observable } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'cpak-p403',
  templateUrl: './p403.component.html',
  styleUrls: ['./p403.component.scss'],
})
export class P403Component {
  public readonly imageUrl = '/assets/images/403.png';
  public readonly dashboardLink = RoutingUrls.Dashboard;
  public isLoginFailed$: Observable<boolean> = this.authService.getLoginFailedState();
  public routeQueryParams: Observable<Params> = this.activatedRoute.queryParams;

  constructor(private authService: AuthService, private activatedRoute: ActivatedRoute) {}
}
